module.exports = __webpack_public_path__ + "static/img/MockServices.5993b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MockServices.png
// module id = cVn5
// module chunks = 1